export const wrapperStyles = {
  position: 'fixed',
  zIndex: 900,
  bottom: '12px',
  left: '12px',
  gap: '8px',
  padding: '12px',
  borderRadius: ({ shape }) => shape.radius.l,
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const labelRowStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
};
